module.exports = __webpack_public_path__ + "media/images/logo-main-942e2bb5214410e562f3e5fc9f7f9602.svg";